(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accio-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
(function() {
  var hero = document.getElementById('accio-hero-slideshow');
  if (!hero) return;
  var track = document.getElementById('accio-hero-track');
  var dots = document.querySelectorAll('#accio-hero-dots .accio-hero__dot');
  if (!track || dots.length < 2) return;

  var total = dots.length;
  var current = 0;
  var timer = null;
  var autoDelay = 5000;

  function goTo(index) {
    current = (index + total) % total;
    track.style.transform = 'translateX(-' + (current * 100) + '%)';
    dots.forEach(function(d, i) {
      d.classList.toggle('accio-hero__dot--active', i === current);
    });
  }

  function startAuto() {
    timer = setInterval(function() {
      goTo(current + 1);
    }, autoDelay);
  }

  function stopAuto() {
    clearInterval(timer);
  }

  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() {
      stopAuto();
      goTo(i);
      startAuto();
    });
  });

  hero.addEventListener('mouseenter', stopAuto);
  hero.addEventListener('mouseleave', startAuto);

  startAuto();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
